export default __webpack_public_path__ + "static/media/upperLogin-image.668695c0.png";